import { GetLevels } from '../api/queries/get-levels';

const defaultWhenNoData: boolean = true;

export function useOnlyTop(): boolean {
  const getLevels = GetLevels.useQuery({ retry: 3 });

  const onlyTop = getLevels.data
    ? getLevels.data.levels.top === getLevels.data.levels.unit
    : defaultWhenNoData;

  return onlyTop;
}
